import * as GCashApiService from '../services/api/requests/GCash'

// gets gcash status
export const doGetGCashStatus = async ({
  accessToken,
  onSuccess = () => {},
  onError = () => {},
}) => {
  // REMOVED - getGCashStatus function no longer exists
  // try {
  //   const response = await GCashApiService.getGCashStatus(accessToken)
  //   onSuccess(response)
  // } catch (err) {
  onError(new Error('getGCashStatus function no longer exists'))
  // }
}

// links gcash
export const doLinkGCash = async ({
  accessToken,
  onSuccess = () => {},
  onError = () => {},
}) => {
  // REMOVED - linkGCash function no longer exists
  // try {
  //   const response = await GCashApiService.linkGCash(accessToken)
  //   onSuccess(response)
  // } catch (err) {
  onError(new Error('linkGCash function no longer exists'))
  // }
}

// unlinks gcash
export const doUnlinkGCash = async ({
  accessToken,
  onSuccess = () => {},
  onError = () => {},
}) => {
  // REMOVED - unlinkGCash function no longer exists
  // try {
  //   const response = await GCashApiService.unlinkGCash(accessToken)
  //   onSuccess(response)
  // } catch (err) {
  onError(new Error('unlinkGCash function no longer exists'))
  // }
}

// GCash x Zing Referral
export const doGetGCashReferralCode = async ({
  accessToken,
  onSuccess = () => {},
  onError = () => {},
}) => {
  try {
    const { data } = await GCashApiService.getMerchantReferralCodeByMerchant({
      merchantName: 'GCash',
      accessToken,
    })
    // const allMerchants = await GCashApiService.getAllMerchantReferralCode(accessToken)
    onSuccess(data)
  } catch (err) {
    console.log('get referral codes catch error: ', { err })
    onError(err)
  }
}
